export const MOBILE_API_URL = '/mobileapi'
export const WORKSPACE_ACTIONS_URL = '/workspaceactions'
export const WORKSHEET_ACTIONS_URL = '/worksheetactions'
export const SHEET_SERVER_URL = '/sheetserver'
export const BOT_ACTION_URL = '/botactions'
export const CANVAS_API_URL = '/canvasV2'
export const SCOOP_WEB_API_URL = '/scoopwebapi'
export const EVENT_URL = '/event'
export const UI_INFORMATION_URL = '/ui_information'
export const CHATS_HANDLER = '/scoop-chat/chats'
export const PROVISION_USER_URL = '/provisionnewuser'
